var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard-delete-button red mr-1 font-weight-light",style:(`
      ${_vm.value?'width: 66px !important; border-radius: 3px !important; ':''}
      ${_vm.value && _vm.direction === 'left'?'margin-left: -46px; ':''}
      zoom: ${_vm.zoom?_vm.zoom:'var(--taktplan_zoom); '}
    `),on:{"mouseleave":function($event){_vm.value = false},"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.value?
      _vm.$emit('clickDelete')
      :
      _vm.value = true}}},[(_vm.value)?[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete")]),_c('div',[_vm._v(_vm._s(_vm.$t('Buttons.Delete')))])]:_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }